'use strict';

const Backbone = require('backbone');
const CommentReactionAction = require('communication/domain/comment-reaction/action');

class CommentReactionActionCollection extends Backbone.Collection {
    constructor(models, options) {
        super(models, options);

        this.model = CommentReactionAction;
    }

    static comparator(model) {
        return model.actionAt.unix();
    }

    getByUserKey(userKey) {
        return this.where({userKey: userKey.toString()})[0];
    }

    hasByUserKey(userKey) {
        return this.where({userKey: userKey.toString()}).length >= 1;
    }
}

module.exports = CommentReactionActionCollection;



// WEBPACK FOOTER //
// ./communication/domain/comment-reaction/action-collection.js